export type OnboardingSwipeAction = "next" | "previous";

export type OnboardingSwipeEvent = {
  translationX: number;
  translationY: number;
  velocityX: number;
};

const MIN_SWIPE_DISTANCE = 56;
const MIN_FLING_DISTANCE = 24;
const MIN_FLING_VELOCITY = 650;
const HORIZONTAL_INTENT_RATIO = 1.25;

export const getOnboardingSwipeAction = ({
  translationX,
  translationY,
  velocityX,
}: OnboardingSwipeEvent): OnboardingSwipeAction | null => {
  "worklet";
  const horizontalDistance = Math.abs(translationX);
  const verticalDistance = Math.abs(translationY);

  if (
    horizontalDistance <= verticalDistance * HORIZONTAL_INTENT_RATIO ||
    horizontalDistance === 0
  ) {
    return null;
  }

  const crossedDistance = horizontalDistance >= MIN_SWIPE_DISTANCE;
  const flingMatchesDirection =
    Math.sign(velocityX) === Math.sign(translationX);
  const crossedFlingThreshold =
    horizontalDistance >= MIN_FLING_DISTANCE &&
    Math.abs(velocityX) >= MIN_FLING_VELOCITY &&
    flingMatchesDirection;

  if (!crossedDistance && !crossedFlingThreshold) {
    return null;
  }

  return translationX < 0 ? "next" : "previous";
};
